import { ConfigProvider, Drawer, Radio } from 'antd';
import styled from 'styled-components';
import { useState } from 'react';
import { Button, Colors, Row, Text } from 'basic-ui-lib';
import { StatusOptions } from 'modules/dashboard/services/constants';
import useGetListScreens from 'modules/dashboard/services/hooks/useGetListScreens';

interface ScreenFilterDrawerMobileProps {
  open?: boolean;
  onClose?: () => void;
}

const ScreenFilterDrawerMobile = ({ open, onClose }: ScreenFilterDrawerMobileProps) => {
  const { screensParams, mutate } = useGetListScreens(true);
  const [tempValue, setTempValue] = useState(screensParams.status || '');

  const handleFilterApply = () => {
    mutate({
      status: tempValue || '',
      page: 1,
      size: 10,
    });
    onClose?.();
  };

  const handleClose = () => {
    setTempValue(screensParams.status || '');
    onClose?.();
  };

  return (
    <ConfigProvider>
      <StyledDrawer
        title={
          <DrawerHeader>
            <Text title_h6 semibold center>
              Filter
            </Text>
          </DrawerHeader>
        }
        placement='bottom'
        closable={false}
        onClose={handleClose}
        open={open}
        height='auto'
        footer={
          <Row>
            <Button type_cancel lg onClick={handleClose} style={{ width: '100%' }}>
              Close
            </Button>
            <Button type_second lg style={{ width: '100%' }} onClick={handleFilterApply}>
              OK
            </Button>
          </Row>
        }
        destroyOnClose
        style={{borderRadius: '10px 10px 0px 0px'}}
      >
        <Text content_2 medium left>
          Status
        </Text>
        <Radio.Group
          optionType='button'
          buttonStyle='outline'
          value={tempValue}
          onChange={(e) => setTempValue(e.target.value)}
        >
          {StatusOptions.map((option) => (
            <Radio.Button key={option.value} value={option.value} onClick={() => setTempValue(option.value)}>
              {option.label}
            </Radio.Button>
          ))}
        </Radio.Group>
      </StyledDrawer>
    </ConfigProvider>
  );
};

export default ScreenFilterDrawerMobile;

const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 16px 16px 32px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    background-color: ${Colors.neutral.bg[2]};
  }

  .ant-drawer-footer {
    padding: 16px 16px;
    box-shadow: 0px -4px 8px 0px #0000001a;
    background-color: ${Colors.neutral.bg[1]};
  }

  .ant-radio-group {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }

  .ant-radio-button-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 48px;
    border-radius: 100px;
    background-color: ${Colors.neutral.bg[1]};
    border: 1px solid ${Colors.neutral.border[2]};
  }

  .ant-radio-button-wrapper:not(:first-child)::before {
    display: none;
  }

  .ant-radio-button-label {
    font-size: 14px;
    font-weight: 500;
  }

  .ant-radio-button-wrapper-checked {
    background-color: ${Colors.secondary[5]}!important;
    border-color: ${Colors.secondary[5]}!important;
  }

  .ant-radio-button-wrapper-checked .ant-radio-button-label {
    color: #ffffff;
  }
`;

const DrawerHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
